
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  template: `<div v-html="text"></div>`
})

export default class DescriptionText extends Vue {
  @Prop({ default: '' }) text: string
}
